import {
  addCartApi,
  getCartApi,
  removeCartApi,
  updateCartApi,
  getPriceApi,
  mergeTicketApi,
} from 'app/services/cartApi';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import {
  ADD_CART,
  GET_CART,
  GET_TICKET_PRICE,
  REMOVE_CART,
  UPDATE_CART,
  MERGE_TICKET,
} from '.';
import { I_CartItem } from './types';
import { getItem, setItem } from 'utils/localStorage';
import { TYPE_LOCAL_STORAGE } from 'utils/constants';
import { generateTicketIdentify } from '../utils';

export function* getCart({ payload }: any) {
  const { onSuccess, payloadData } = payload;
  try {
    const { data } = yield call(getCartApi, payloadData);
    yield put(GET_CART.success(data));
    onSuccess?.(data);
    // Remove tickets does not retrieve data at cart page
    // const isLogged = yield select(state => state.app.isLogged);
    // if (window.location.pathname === '/cart' && !isLogged) {
    //   const cartLocal = JSON.parse(getItem(TYPE_LOCAL_STORAGE.CART) ?? '[]');
    //   const ticketsLocalRetrieveData = cartLocal?.filter(i => {
    //     const iIdentify = generateTicketIdentify({
    //       showId: i?.show_id,
    //       performanceId: i?.performance,
    //       zoneId: i?.zone_id,
    //       date: i?.date,
    //     });

    //     return data.find((j: I_CartItem) => {
    //       const jIdentify = generateTicketIdentify({
    //         showId: j?.show?.id,
    //         performanceId: j?.performance?.id,
    //         zoneId: j?.zone?.id,
    //         date: j?.date,
    //       });

    //       return iIdentify === jIdentify;
    //     });
    //   });

    //   setItem(
    //     TYPE_LOCAL_STORAGE.CART,
    //     JSON.stringify(ticketsLocalRetrieveData, function (k, v) {
    //       return v === undefined ? null : v;
    //     }),
    //   );
    // }
  } catch (err) {
    yield put(GET_CART.failure());
  }
}

export function* updateCart({ payload }: any) {
  const { data, onSuccess, onError } = payload;
  try {
    const { data: responseData } = yield call(updateCartApi, data);
    const currentCart = yield select(state => state.cart?.cart);
    onSuccess?.(responseData, currentCart);
    yield put(UPDATE_CART.success(responseData));
  } catch (err: any) {
    onError?.(err);
    yield put(UPDATE_CART.failure(err));
  }
}

export function* addCart({ payload }: any) {
  const { data, onSuccess, onError } = payload;
  try {
    const { data: responseData } = yield call(addCartApi, data);
    onSuccess?.(responseData);
    yield put(ADD_CART.success(data));
  } catch (err: any) {
    onError?.(err);
    yield put(ADD_CART.failure());
  }
}

export function* removeCart({ payload }: any) {
  const { data, onSuccess, onError } = payload;
  try {
    const { data: responseData } = yield call(removeCartApi, data);
    yield put(REMOVE_CART.success(responseData));
    onSuccess?.(responseData);
  } catch (err) {
    onError?.(err);
    yield put(REMOVE_CART.failure());
  }
}

export function* getTicketPrice({ payload }: any) {
  const { data, ticketIdentify, onSuccess, onError, isCallUpdateCartApi } =
    payload;
  try {
    const { data: responseData } = yield call(getPriceApi, data);
    const currentCart = yield select(state => state.cart?.cart);

    const isAnyError = responseData?.some(ticket => ticket?.error);

    yield put(
      GET_TICKET_PRICE.success({
        data: responseData,
        ticketIdentify,
        isCallUpdateCartApi: isAnyError ? false : isCallUpdateCartApi,
      }),
    );
    onSuccess?.(responseData, currentCart);
  } catch (err: any) {
    yield put(GET_TICKET_PRICE.failure({ error: err, ticketIdentify }));
    onError?.(err);
  }
}

export function* mergeTicket({ payload }: any) {
  const { data, onSuccess, onError } = payload;
  try {
    const { data: responseData } = yield call(mergeTicketApi, data);
    const currentCart = yield select(state => state.cart?.cart);
    onSuccess?.(responseData, currentCart);
    yield put(MERGE_TICKET.success(responseData));
  } catch (err: any) {
    const currentCart = yield select(state => state.cart?.cart);
    onError?.(err, currentCart);
    yield put(MERGE_TICKET.failure(err));
  }
}

export function* cartSaga() {
  yield takeLatest(GET_CART.TRIGGER, getCart);
  yield takeLatest(ADD_CART.TRIGGER, addCart);
  yield takeLatest(REMOVE_CART.TRIGGER, removeCart);
  yield takeLatest(UPDATE_CART.TRIGGER, updateCart);
  yield takeLatest(MERGE_TICKET.TRIGGER, mergeTicket);
  yield takeLatest(GET_TICKET_PRICE.TRIGGER, getTicketPrice);
}
